import { render, staticRenderFns } from "./FeedVideo.vue?vue&type=template&id=7f2372b5"
import script from "./FeedVideo.vue?vue&type=script&lang=js"
export * from "./FeedVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports